import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.last-index-of.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import cloneDeep from 'lodash/cloneDeep';
import { fetchCreate, fetchUpdate, fetchDetail, checkAcc } from '@/api/system/user/user';
import { fetchDeptTree } from '@/api/system/dept/dept';
import { getToken } from '@/utils/auth'; // getToken from cookie

import { fetchList } from '@/api/system/pos/pos';
import md5 from 'js-md5';
export default {
  props: ['keyValue', 'showDialog'],
  data: function data() {
    var _this = this;

    var fileMustUpload = function fileMustUpload(rule, value, callback) {
      console.log(_this.fileList, 'sssss');

      if (_this.fileList.length === 0) {
        // 未上传文件
        callback("请上传照片");
      }

      callback();
    };

    var LxStr = function LxStr(str) {
      var arr = str.split('');
      var flag = true;

      for (var i = 1; i < arr.length - 1; i++) {
        var firstIndex = arr[i - 1];
        var secondIndex = arr[i];
        var thirdIndex = arr[i + 1];
        thirdIndex - secondIndex === 1;
        secondIndex - firstIndex === 1;

        if (thirdIndex - secondIndex === 1 && secondIndex - firstIndex === 1) {
          flag = false;
        }
      }

      return flag;
    };

    var validateAcc = function validateAcc(rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入正确账号'));
      } else {
        checkAcc(_this.keyValue, _this.childData.userAcc).then(function (response) {
          if (response.data.data.personNum > 0) {
            callback(new Error('该账号已被占用'));
          } else {
            callback();
          }
        });
      }
    };

    var validatePass = function validatePass(rule, value, callback) {
      if (!value) {
        callback(new Error('请输入密码'));
      } else {
        var reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@#!%*?&._])[A-Za-z\d$@#!%*?&._]{8,16}/;

        if (value.length < 8 || value.length > 16) {
          callback(new Error('密码长度必须为8~16位'));
        } else if (!reg.test(value)) {
          callback(new Error('密码必须同时包含大小写字母、数字、特殊字符'));
        } else if (!LxStr(value)) {
          callback(new Error('数字不能连续三位'));
        } else {
          callback();
        }
      }
    }; // 身份证号校验


    var checkIdentitytionId = function checkIdentitytionId(rule, value, callback) {
      if (!value) {
        return callback(new Error('身份证号不能为空'));
      }

      value = value.toUpperCase();

      if (!/(^\d{15}$)|(^\d{17}(\d|X|x)$)/.test(value)) {
        callback(new Error('你输入的身份证长度或格式错误'));
      } // 身份证城市


      var aCity = {
        11: '北京',
        12: '天津',
        13: '河北',
        14: '山西',
        15: '内蒙古',
        21: '辽宁',
        22: '吉林',
        23: '黑龙江',
        31: '上海',
        32: '江苏',
        33: '浙江',
        34: '安徽',
        35: '福建',
        36: '江西',
        37: '山东',
        41: '河南',
        42: '湖北',
        43: '湖南',
        44: '广东',
        45: '广西',
        46: '海南',
        50: '重庆',
        51: '四川',
        52: '贵州',
        53: '云南',
        54: '西藏',
        61: '陕西',
        62: '甘肃',
        63: '青海',
        64: '宁夏',
        65: '新疆',
        71: '台湾',
        81: '香港',
        82: '澳门',
        91: '国外'
      };

      if (!aCity[parseInt(value.substr(0, 2))]) {
        callback(new Error('你的身份证地区非法'));
      } // 出生日期验证


      var sBirthday = (value.substr(6, 4) + '-' + Number(value.substr(10, 2)) + '-' + Number(value.substr(12, 2))).replace(/-/g, '/');
      var d = new Date(sBirthday);

      if (sBirthday !== d.getFullYear() + '/' + (d.getMonth() + 1) + '/' + d.getDate()) {
        callback(new Error('身份证上的出生日期非法'));
      } // 身份证号码校验


      var sum = 0;
      var weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
      var codes = '10X98765432';

      for (var i = 0; i < value.length - 1; i++) {
        sum += value[i] * weights[i];
      }

      var last = codes[sum % 11]; // 计算出来的最后一位身份证号码

      if (value[value.length - 1] != last) {
        callback(new Error('你输入的身份证号非法'));
      }

      callback();
    };

    return {
      userList: [],
      pwdVisable: true,
      options: [],
      postOption: [],
      userStateOption: [{
        value: 1,
        label: '禁用'
      }, {
        value: 0,
        label: '启用'
      }],
      rules: {
        userAcc: [{
          required: true,
          message: '请输入用户账号',
          trigger: 'change'
        }, {
          min: 2,
          max: 50,
          message: '长度在 2 到 50 个字符',
          trigger: 'change'
        }, {
          validator: validateAcc,
          trigger: 'blur'
        }],
        files: [{
          required: true,
          validator: fileMustUpload,
          trigger: 'blur'
        }],
        userPwd: [{
          required: true,
          validator: validatePass,
          trigger: 'blur'
        }, {
          min: 2,
          max: 50,
          message: '长度在 2 到 50 个字符',
          trigger: 'change'
        }],
        userName: [{
          required: true,
          message: '请输入用户名',
          trigger: 'change'
        }, {
          min: 2,
          max: 50,
          message: '长度在 2 到 50 个字符',
          trigger: 'change'
        }],
        mobilephone: [{
          required: true,
          message: '请输入手机号',
          trigger: 'blur'
        }, {
          min: 11,
          max: 11,
          message: '请输入11位手机号',
          trigger: 'change'
        }],
        userSerno: [{
          required: true,
          validator: checkIdentitytionId,
          trigger: 'blur'
        }],
        userState: [{
          required: true,
          message: '请选择用户状态',
          trigger: 'change'
        }],
        upIdList: [{
          required: true,
          message: '请选择用户所属部门',
          trigger: 'change'
        }],
        aspRemark: [{
          max: 200,
          message: '最多可输入 200 个字符',
          trigger: 'change'
        }]
      },
      propstree: {
        label: 'deptName',
        value: 'deptId',
        children: 'childDept'
      },
      userId: 0,
      usertype: '',
      childData: {},
      files: [],
      fileList: [],
      changeFileList: [],
      delImg: [],
      dialogImageUrl: '',
      dialogVisible: false,
      importHeaders: {
        'access-token': getToken()
      },
      uploadUrl: '',
      downloadUrl: ''
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      var _this2 = this;

      if (n) {
        this.$nextTick(function () {
          _this2.options = [];
          _this2.postOption = [];

          _this2.$refs['dataForm'].resetFields();

          if (_this2.showDialog) {
            _this2.init();
          }
        });
      }
    }
  },
  created: function created() {
    this.uploadUrl = process.env.VUE_APP_UPLOAD;
    this.downloadUrl = process.env.VUE_APP_DOWNLOAD;
    this.init();
    this.files = [];
  },
  methods: {
    changeUser: function changeUser(val) {
      this.childData.userName = val.userName;
      this.childData.mobilephone = val.mobilephone;
    },
    init: function init() {
      this.changeFileList = [];
      this.usertype = this.$store.state.user.userType;
      this.options = [];
      this.postOption = [];
      this.delImg = [];
      this.files = [];
      this.fileList = [];
      this.loadDeptTree();
      this.loadPostList();
      this.loadData();
    },
    loadData: function loadData() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.$refs['dataForm'].clearValidate();
      });

      if (this.keyValue > 0) {
        this.pwdVisable = false;
        var queryData = {
          userId: this.keyValue
        };
        var upDeptIds = [];
        fetchDetail(queryData).then(function (response) {
          _this3.childData = response.data.data;

          if (_this3.childData.upIdList.length > 0) {
            _this3.childData.upIdList.forEach(function (e) {
              upDeptIds.push(e.toString());
            });
          }

          upDeptIds.push(_this3.childData.deptId.toString());
          _this3.childData.upIdList = upDeptIds;
          _this3.childData.deleteUserImgVo = {};
          var imgData = {
            fileId: _this3.childData.imgPath,
            fileType: 2,
            id: _this3.childData.imgPath,
            imgPath: _this3.childData.imgPath,
            imgId: _this3.childData.imgPath,
            url: _this3.downloadUrl + _this3.childData.imgPath
          };

          _this3.fileList.push(imgData);

          _this3.files = cloneDeep(_this3.fileList);
          _this3.changeFileList = _this3.fileList; // if (this.childData.userImgListVos !== null) {
          //     this.childData.userImgListVos.forEach(item => {
          //         const imgData = {
          //             fileId: item.imgPath,
          //             fileType: 2,
          //             id: item.id,
          //             imgPath: item.imgPath,
          //             imgId: item.imgId,
          //             url: this.downloadUrl + item.imgPath
          //         }
          //         this.fileList.push(imgData)
          //     })
          //     this.files = cloneDeep(this.fileList)
          // }
        });
      } else {
        this.pwdVisable = true;
        this.userId = 0;
        this.childData = {
          userImgListVos: [],
          deleteUserImgVo: {
            ids: []
          }
        };
      }
    },
    loadDeptTree: function loadDeptTree() {
      var _this4 = this;

      var treeQuery = {};
      fetchDeptTree(treeQuery).then(function (response) {
        _this4.options = response.data.data;
      });
    },
    loadPostList: function loadPostList() {
      var _this5 = this;

      var treeQuery = {};
      fetchList(treeQuery).then(function (response) {
        _this5.postOption = response.data.data;
      });
    },
    handCreate: function handCreate() {
      var _this6 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          _this6.childData.deptId = null;
          _this6.childData.deptId = _this6.childData.upIdList[_this6.childData.upIdList.length - 1];
          delete _this6.childData.upIdList;
          _this6.childData.changeUserImgVos = _this6.changeFileList;
          _this6.childData.deleteUserImgVo.ids = _this6.delImg;
          _this6.childData.imgPath = _this6.changeFileList[0].imgPath;

          if (_this6.keyValue > 0) {
            _this6.childData.changeUserImgVos.forEach(function (item) {
              item.id = _this6.childData.userId;
            });

            fetchUpdate(_this6.childData).then(function () {
              _this6.$emit('handCancle', true);

              _this6.Alert({
                alertType: 'update'
              });
            });
          } else {
            var childDataClone = JSON.parse(JSON.stringify(_this6.childData));
            childDataClone.userPwd = md5(childDataClone.userPwd);
            childDataClone.userType = _this6.usertype;
            fetchCreate(childDataClone).then(function () {
              _this6.$emit('handCancle', true);

              _this6.Alert({
                alertType: 'add'
              });
            });
          }
        } else {
          _this6.Alert({
            alertType: 'valid'
          });
        }
      });
    },
    handCancle: function handCancle() {
      this.$emit('handCancle', false);
    },
    handleSuccess: function handleSuccess(response, file) {
      this.fileList.push({
        name: response.data[0].fileName,
        imgName: response.data[0].fileName,
        fileType: this.judgeFileType(file.raw.type),
        imgPath: response.data[0].fileId,
        fileId: response.data[0].fileId
      });
      this.changeFileList.push({
        name: response.data[0].fileName,
        imgName: response.data[0].fileName,
        fileType: this.judgeFileType(file.raw.type),
        imgPath: response.data[0].fileId,
        fileId: response.data[0].fileId
      });
      this.$refs.dataForm.clearValidate('files');
    },
    handleExceed: function handleExceed() {
      this.$message({
        message: '最多只能上传1个文件!',
        type: 'danger'
      });
    },
    handlePreview: function handlePreview(file) {
      if (file.response !== undefined) {
        // 当还未保存到业务逻辑中时的预览图片
        if (file.raw.type === 'image/png' || file.raw.type === 'image/jpeg' || file.raw.type === 'image/jpg') {
          // 当附件是图片的时候在线打开
          this.dialogVisible = true;
          this.dialogImageUrl = this.downloadUrl + file.response.data[0].fileId;
        } else {
          // 当附件是文件的时候在线下载
          this.dialogImageUrl = this.downloadUrl + file.response.data[0].failId;
          this.handleDownload(this.dialogImageUrl, file.name);
        }
      } else {
        // 当已保存到业务逻辑中时的预览图片
        if (file.fileType === 2) {
          // 当附件是图片的时候在线打开
          this.dialogVisible = true;
          this.dialogImageUrl = file.url;
        } else {
          // 当附件是文件的时候在线下载
          this.dialogImageUrl = file.url;
          this.handleDownload(this.dialogImageUrl, file.name);
        }
      }
    },
    // 移除图片之前做的操作
    beforeRemove: function beforeRemove(file, fileList) {// return this.$confirm(`确定移除 ${ file.name }？`)
    },
    beforeUpload: function beforeUpload(file) {
      var extension = file.name.substring(file.name.lastIndexOf('.') + 1);
      extension = extension.toLowerCase();
      var isLt2M = file.size / 1024 / 1024 < 10;
      var fileFormatOK = extension === 'jpg' || extension === 'jpeg' || extension === 'JPEG' || extension === 'png' || extension === 'bmp' || extension === 'gif';

      if (!fileFormatOK) {
        this.$message({
          message: '只支持上传 jpg/jpeg/png/bmp/gif 格式文件!',
          type: 'error'
        });
        return false;
      }

      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 10MB!',
          type: 'error'
        });
        return false;
      }
    },
    // 移除图片
    handleRemove: function handleRemove(file) {
      var _this7 = this;

      var currentUrl = 0; // 获取当前删除文件的fileId

      if (file.response !== undefined) {
        // 文件是新增加的
        currentUrl = file.response.data[0].fileId;
      } else {
        // 文件是旧数据
        currentUrl = file.fileId;
        this.delImg.push(file.imgId);
      }

      this.files.forEach(function (item, index) {
        if (currentUrl === item.fileId) {
          _this7.files.splice(index, 1);

          return;
        }
      });
      this.fileList.forEach(function (item, index) {
        if (currentUrl === item.fileId) {
          _this7.fileList.splice(index, 1);

          return;
        }
      });
      this.changeFileList.forEach(function (item, index) {
        if (currentUrl === item.fileId) {
          _this7.changeFileList.splice(index, 1);

          return;
        }
      });
    },
    // 下载文件
    handleDownload: function handleDownload(url, name) {
      var link = document.createElement('a');
      link.style.display = 'none';
      link.href = url;
      link.setAttribute('download', name);
      document.body.appendChild(link);
      link.click();
    },
    // 判断上传的文件类型，方便数据库保存
    judgeFileType: function judgeFileType(str) {
      if (str === 'image/png' || str === 'image/jpeg' || str === 'image/jpg' || str === 'image/gif' || str === 'image/bmp') {
        return 2;
      } else {
        return 1;
      }
    }
  }
};